import {ConnectedComponent} from 'lowkey-component';

import {TextAnimation} from '@components/helpers/TextAnimation';
import {getAbsoluteTop, sleep} from '@lib/utils';
import {MediaQuery} from '@services/MediaQuery';
import {appSelectors} from '@store/appSlice';

type AnimationStartType = 'scrolled' | 'viewport' | 'firstview';

export class TextViewportAnimation extends ConnectedComponent {
  mq = MediaQuery.create();
  observer: IntersectionObserver | null = null;
  textAnimation: TextAnimation | null = null;
  type: AnimationStartType = 'viewport';
  device = '';

  constructor(element: HTMLDivElement) {
    super(element);
    this.textAnimation = new TextAnimation(element);
  }

  isFirstView() {
    const top = getAbsoluteTop(this.element);
    return top < window.innerHeight;
  }

  didMount() {
    this.textAnimation?.init();

    const animationStartType = this.element.dataset[
      'type'
    ] as AnimationStartType;
    if (animationStartType) {
      this.type = animationStartType || 'viewport';
    } else if (this.isFirstView()) {
      this.type = 'firstview';
    }
    if (animationStartType === 'scrolled' && this.mq.isPhone()) {
      this.type = 'viewport';
    }
    switch (this.type) {
      case 'viewport':
        this.device = this.element.dataset['device'] || '';
        this.observer = new IntersectionObserver(this.onIntersection, {
          rootMargin: '0px',
          threshold: [0, 1],
        });
        this.observer.observe(this.element);
        return;
      case 'firstview':
        this.observe(appSelectors.selectSiteIndicatorStatus, async (status) => {
          if (status === 'hidingAnimation') {
            await sleep(100);
            this.textAnimation?.show();
          }
        });

        this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
          if (status === 'startHideAnimation') {
            await sleep(100);
            this.textAnimation?.show();
          }
        });
        return;
      case 'scrolled':
        this.textAnimation?.hide();
        this.observe(appSelectors.selectOneViewStatus, async (status) => {
          if (status === 'down') {
            this.textAnimation?.hide();
            await sleep(100);
            // backdrop.process(this.element)
            this.textAnimation?.show();
          }
          if (status === 'up') {
            this.textAnimation?.hide();
          }
        });
    }
  }

  didUnmount() {
    this.observer?.disconnect();
  }

  onIntersection = (entries: IntersectionObserverEntry[]) => {
    if (
      (this.mq.isDesktop() && this.device === 'phone') ||
      (this.mq.isPhone() && this.device === 'desktop')
    ) {
      return;
    }
    for (const entry of entries) {
      // 画面の下でintersectionしたかどうか
      // const isBottomArea = entry.boundingClientRect.top > window.innerHeight / 2
      const isBottomArea = entry.boundingClientRect.top > 0;
      if (isBottomArea) {
        if (!entry.isIntersecting) {
          this.textAnimation?.hide();
        }
        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          this.textAnimation?.show();
        }
      }
    }
  };
}
